import { writable } from "svelte/store";

export const isLoadingMore = writable<boolean>(false);
